import React from 'react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

interface AnimatedSectionProps {
  children: React.ReactNode;
  animation?: 'fade-up' | 'fade-down' | 'fade-left' | 'fade-right' | 'zoom-in' | 'bounce-in';
  className?: string;
  threshold?: number;
  rootMargin?: string;
  once?: boolean;
  delay?: boolean;
  onVisible?: () => void;
}

export function AnimatedSection({
  children,
  animation = 'fade-up',
  className = '',
  threshold = 0.1,
  rootMargin = '0px',
  once = true,
  delay = false,
  onVisible,
}: AnimatedSectionProps) {
  const ref = useScrollAnimation({ threshold, rootMargin, once, onVisible });

  const getAnimationClass = () => {
    switch (animation) {
      case 'fade-up':
        return '[&.animate-in]:animate-fade-up';
      case 'fade-down':
        return '[&.animate-in]:animate-fade-down';
      case 'fade-left':
        return '[&.animate-in]:animate-fade-left';
      case 'fade-right':
        return '[&.animate-in]:animate-fade-right';
      case 'zoom-in':
        return '[&.animate-in]:animate-zoom-in';
      case 'bounce-in':
        return '[&.animate-in]:animate-bounce-in';
      default:
        return '[&.animate-in]:animate-fade-up';
    }
  };

  return (
    <div
      ref={ref}
      className={`opacity-0 ${getAnimationClass()} ${
        delay ? 'delay-200' : ''
      } ${className}`}
    >
      {children}
    </div>
  );
} 
